import { createStore } from "vuex";

import suppliers from "./suppliers";
import supplierCategory from "./supplierCategory";
import snackbar from "./snackbar";
const store = createStore({
  strict: false,
  state: {},
  mutations: {},
  actions: {},
  modules: {
    suppliers,
    supplierCategory,
    snackbar,
  },
});

export default store;
